module.exports = __webpack_public_path__ + "img/gmoa_terry_allen.1d4e42ec.jpg";